import React, { useState } from 'react';
import { Copy, Check, Link, Share2 } from 'lucide-react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MasterReferralLinkCard = ({ referralCode, referralLink }) => {
  const [copiedLink, setCopiedLink] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard?.writeText(referralLink);
      setCopiedLink(true);
      setTimeout(() => setCopiedLink(false), 2000);
    } catch (error) {
      console.error('Failed to copy link:', error);
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
          <Icon name="Share2" size={24} className="text-indigo-600" />
        </div>
        <div>
          <h2 className="text-lg font-heading font-bold text-foreground">Master Referral Link</h2>
          <p className="text-sm text-muted-foreground">Share your exclusive referral link</p>
        </div>
      </div>

      {/* Referral Code Display */}
      <div className="bg-gray-50 rounded-lg p-4 mb-4">
        <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 block">
          Referral Code
        </label>
        <div className="flex items-center gap-2">
          <code className="text-2xl font-bold font-mono text-indigo-600 tracking-wider">
            {referralCode}
          </code>
        </div>
      </div>

      {/* Referral Link Display */}
      <div className="bg-gray-50 rounded-lg p-4 mb-4">
        <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 block">
          Shareable Link
        </label>
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={referralLink}
            readOnly
            className="flex-1 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm text-foreground font-mono"
          />
          <Button
            variant={copiedLink ? 'success' : 'default'}
            size="sm"
            onClick={handleCopyLink}
            iconName={copiedLink ? 'Check' : 'Copy'}
          >
            {copiedLink ? 'Copied!' : 'Copy'}
          </Button>
        </div>
      </div>

      {/* Info Message */}
      <div className="flex items-start gap-2 p-3 bg-indigo-50 rounded-lg">
        <Icon name="Info" size={16} className="text-indigo-600 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-indigo-700">
          Share this link to invite users to MyBodyToday. Track referral performance in the Referral Rewards Panel below.
        </p>
      </div>
    </div>
  );
};

export default MasterReferralLinkCard;